module.exports = __webpack_public_path__ + "img/2_3.edc86ed5.png";